import { Navigation } from "./Navigation";
export class HttpForm {
    loaded = false;
    submitting = false;
    success = false;
    error = false;
    navigation = new Navigation;
    exportFormats = [
        { value: 'Csv', name: 'Comma Seperated File (.csv)' },
        { value: 'Xls', name: 'Excel Spreadsheet (.xls)' },
    ];
    export_format = 'Csv';
    constructor() {
        let exportFormat = localStorage.getItem('default_export_format');
        if (exportFormat) {
            this.export_format = exportFormat;
        }
        this.updateDownloadFormat();
        this.clearFieldErrors();
    }
    setLoadingState(state) {
        this.loaded = state;
        return this;
    }
    isLoaded() {
        return this.loaded;
    }
    setError(error) {
        this.unsetSubmitting();
        if (error.response !== undefined) {
            this.error = error.response;
        }
        if (this.error && (this.error.status === 401 || this.error.status === 419)) {
            this.navigation.toRouteName('login');
        }
        if (this.error && (this.error.status === 403 || this.error.status === 404)) {
            this.navigation.toRouteName('admin.dashboard');
        }
        throw this.getErrorMessage();
    }
    setSuccessMessage(message, timeout = 4000) {
        let self = this;
        self.success = message;
        if (timeout) {
            setTimeout(function () {
                self.success = false;
            }, timeout);
        }
        this.unsetSubmitting();
    }
    successful() {
        return this.success !== false;
    }
    getSuccessMessage() {
        return this.success;
    }
    hasErrorOccurred() {
        return this.error !== false;
    }
    getErrorMessage() {
        let message = 'An unexpected error occurred, please contact support.';
        if (this.error !== false) {
            let data = this.error.data;
            return data.message ? data.message : message;
        }
        return message;
    }
    resetErrorStatus() {
        this.error = false;
    }
    fieldErrorsPresent() {
        return this.error !== false && this.error.data.errors;
    }
    noFieldErrors() {
        return this.hasErrorOccurred() && !this.fieldErrorsPresent();
    }
    fieldHasErrors(field) {
        if (this.error !== false && this.error.data.errors) {
            return this.error.data.errors.hasOwnProperty(field);
        }
        return false;
    }
    getFieldError(field) {
        if (this.error !== false && this.fieldHasErrors(field)) {
            return this.error.data.errors[field][0];
        }
        return false;
    }
    setFieldError(field, message) {
        if (this.error === false) {
            this.error = { data: { errors: {} } };
        }
        if (!this.error.data.errors) {
            this.error.data.errors = {};
        }
        this.error.data.errors[field] = [message];
    }
    clearFieldErrors() {
        if (this.error !== false && this.error.data.errors) {
            this.error.data.errors = {};
            if (Object.keys(this.error.data.errors).length === 0) {
                this.error = false;
            }
        }
    }
    setupFormSubmission() {
        this.resetFormMessages().then(() => this.setSubmitting());
    }
    resetFormMessages() {
        let self = this;
        return new Promise(resolve => {
            self.submitting = false;
            self.success = false;
            self.error = false;
            resolve(true);
        });
    }
    setSubmitting() {
        this.submitting = true;
        return this;
    }
    unsetSubmitting() {
        this.submitting = false;
        return this;
    }
    isSubmitting() {
        return this.submitting;
    }
    updateDownloadFormat() {
        localStorage.setItem('default_export_format', this.export_format);
    }
    getTimestamp() {
        return new Date().toISOString().slice(0, 19).replace('T', ' ');
    }
}
